/* src/app/layout/card-view-layout/card-view-layout.component.css */
.container {
  padding: 2px 16px;
}
.view-toggle {
  float: right;
  cursor: pointer;
  padding-right: 20px;
  padding-top: 20px;
  height: 50px;
  color: rgba(0, 0, 0, 0.2);
}
.view-toggle .selected {
  color: rgba(0, 0, 0, 0.6);
}
.list {
  width: 90%;
  max-width: 1240px;
  margin: 0 auto;
  margin-top: 20px;
  display: list-item;
  list-style: none;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-gap: 10px;
}
.band {
  width: 100%;
  padding-right: 20px;
  padding-left: 20px;
  padding-top: 0px;
  padding-bottom: 100px;
  max-width: 1240px;
  margin: 0 auto;
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-gap: 10px;
}
@media only screen and (min-width: 500px) {
  .band {
    grid-template-columns: 1fr 1fr;
  }
  .card {
    width: 100%;
  }
  .card-container {
    margin-top: 0px;
  }
}
@media only screen and (min-width: 850px) {
  .band {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  .card-container {
    margin-top: 0px;
  }
}
.title {
  width: 90%;
  max-width: 1240px;
  margin: 0 auto;
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-gap: 10px;
}
/*# sourceMappingURL=card-view-layout.component.css.map */
